import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SafeHtml, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { MainService } from 'src/app/services/main.service';
import { ActivatedRoute } from '@angular/router';
import 'dotdotdot-js'
@Component({
  selector: 'app-market-detail',
  templateUrl: './market-detail.component.html',
  styleUrls: ['./market-detail.component.scss']
})
export class MarketDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: MainService,
    private _sanitizer: DomSanitizer) { }
    language = JSON.parse(localStorage.getItem('language'))

  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';


  market: any;
  showmarket: any;
  detail: any;
  file_pdf: string;
  marketTitle: string;
  marketType: string;
  marketDate: string;
  pdfUrl_path: any;
  pdfUrl: any;

  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.market = this.route.params.subscribe(params => {
      this._mainService.getmarketByID(params['id']).subscribe(response => {
        //case news type is text
        if (this.flag == 'th') {
        if (response[0].market_type === 'text') {
          this.file_pdf = 'no'
          response[0].detail = this.htmlTransforms(response[0].detail)
          this.detail = this.htmlTransforms(response[0].detail)

          this.showmarket = response
          this.marketTitle = response[0].title
          this.marketType = response[0].market_type
          this.marketDate = this._mainService.date_thai(response[0].publicDate)

        } else if (response[0].market_type === 'image') {
          this.file_pdf = 'no'
          this.showmarket = response
          this.detail = response[0].detail
          this.marketTitle = response[0].title
          this.marketType = response[0].market_type
          this.marketDate = this._mainService.date_thai(response[0].publicDate)

        } else if (response[0].market_type === 'pdf') {
          this.file_pdf = 'yes'
          this.pdfUrl_path = response[0].detail
          this.showmarket = response
          this.pdfUrl = this.urlTransform(response[0].detail)
          this.marketTitle = response[0].title
          this.marketType = response[0].market_type
          this.filesize = response[0].filesize

          this.marketDate = this._mainService.date_thai(response[0].publicDate)

        }
        } else {
          if (response[0].market_type === 'text') {
            this.file_pdf = 'no'
            response[0].detail_en = this.htmlTransforms(response[0].detail_en)
            this.detail = this.htmlTransforms(response[0].detail_en)
  
            this.showmarket = response
            this.marketTitle = response[0].title_en
            this.marketType = response[0].market_type
            this.marketDate = response[0].publicDate;
  
          } else if (response[0].market_type === 'image') {
            this.file_pdf = 'no'
            this.showmarket = response
            this.detail = response[0].detail_en
            this.marketTitle = response[0].title_en
            this.marketType = response[0].market_type
            this.marketDate = response[0].publicDate;
  
          } else if (response[0].market_type === 'pdf') {
            this.file_pdf = 'yes'
            this.pdfUrl_path = response[0].detail_en
            this.showmarket = response
            this.pdfUrl = this.urlTransform(response[0].detail_en)
            this.marketTitle = response[0].title_en
            this.marketType = response[0].market_type
            this.filesize = response[0].filesize
  
            this.marketDate = response[0].publicDate;
  
          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }




  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.market.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }







}
